<template>
  <div v-click-outside="onClickOutside" class="edit-on-click">
    <slot v-if="edit" />
    <button
      class="edit-on-click__btn"
      :class="{ nowrap }"
      :disabled="disabled"
      v-else
      @click="edit = true"
    >
      {{ label }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '—',
    },
    nowrap: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    /* eslint-disable */
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (
            el !== event.target &&
            el.className !== 'edit-on-click__btn' &&
            !event.target.closest('.edit-on-click') &&
            !event.target.closest('.edit-on-click__btn')
          ) {
            vnode.context[binding.expression](event);
          }
        };

        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  data: () => ({
    edit: false,
  }),
  methods: {
    onClickOutside() {
      this.edit = false;
    },
  },
};
</script>

<style lang="scss">
.edit-on-click {
  &__btn {
    text-align: left;
    color: #464646;
    font-weight: 600;
    line-height: 1.3;

    &[disabled] {
      font-weight: normal;
    }

    &:not([disabled]):hover {
      opacity: 0.7;
    }

    &.nowrap {
      white-space: nowrap;
    }
  }
}
</style>
